<template>
    <div class="form-group" v-if="form_type == 'search'">
        <v-select multiple :options="options" label="name" v-model="objects" @update:modelValue="inputs" />
        <input v-for="tag in objects" type="hidden" :name="form_attribute" :value="tag.id" />
    </div>
    <div class="form-group" v-else>
        <v-select multiple :options="options" label="name" v-model="objects" @update:modelValue="inputs" />
        <input v-for="tag in objects" type="hidden" :name="form_attribute" :value="tag.id" />
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';

export default {
    name: "TagAutoInputComponent",
    components: { vSelect }, // グローバル登録は不要
    props: {
        default: String,
        type: String,
        label: String,
        attribute_name: String,
        endpoint: String,
        default_id: String
    },
    setup(props) {
        // const selected = ref(props.default ? JSON.parse(props.default) : []);
        const selected_id = ref(props.default_id ? JSON.parse(props.default_id) : []);
        const form_type = ref(props.type || 'search');
        const form_label = ref(props.label || 'タグ検索');
        const form_name_label = ref(props.attribute_name || 'タグ');
        const form_attribute = ref(props.attribute_name ? `${props.attribute_name}[]` : 'tags[]');
        const options = ref([]);
        // const tags = ref([...selected.value]); // 初期値を反映
        const objects = ref([]);

        const inputs = (val) => {
            // console.log("tags:", val);
            // tags.value = val;
            // console.log("Updated tags:", tags.value);
            objects.value = val
        };

        onMounted(async () => {
            console.log('Component mounted.');
            console.log('Default tags:', props.default);

            try {
                const response = await axios.get(props.endpoint || '/api/tags', {
                    params: {
                        attribute: props.attribute_name //クエリパラメータを追加
                    }
                });
                options.value = response.data;

                // ID に一致するオブジェクトを取得して初期値に設定
                objects.value = options.value.filter(
                    option => selected_id.value.includes(option.id)
                )

                console.log(`objects.value`, objects.value);
            } catch (error) {
                console.error('Error fetching tags:', error);
            }
        });

        return {
            // selected,
            selected_id,
            form_type,
            form_label,
            form_attribute,
            options,
            // tags,
            inputs,
            objects
        };
    }
}
</script>
